<h5s-ps-header [filters]="filters()" />
<h5s-ps-filter (filterChange)="filters.set($event)" />
<h5s-ps-table [filters]="filters()" />
